import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3">
            合作咨询
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">
            一起打造更丰富的水果视频平台内容生态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden">
            <div className="p-6 md:p-8">
              <h3 className="font-heading font-semibold text-lg text-foreground-900 mb-3">
                {contactInfo.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                {contactInfo.desc}
              </p>

              <div className="flex flex-wrap gap-2 mb-6">
                {contactInfo.features.map((f) => (
                  <span
                    key={f}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg bg-accent-50 text-accent-700 whitespace-nowrap"
                  >
                    <i className="ri-check-line text-sm"></i>
                    {f}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row gap-4 p-5 rounded-xl bg-background-100">
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-400">合作邮箱</div>
                    <div className="text-sm font-medium text-foreground-800">{contactInfo.email}</div>
                  </div>
                </div>
                <div className="flex items-center gap-3 flex-1">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-xs text-foreground-400">微信公众号</div>
                    <div className="text-sm font-medium text-foreground-800">{contactInfo.wechat}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}